import React from 'react';
import { Spinner } from '@trp-innersource/react-communication';

export interface LoaderProps {
  isVisible: boolean;
}

const Loader: React.FC<LoaderProps> = ({ isVisible }) => {
  if (isVisible) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }
  return null;
};

export default Loader;
